<template>
	<div class="radioGroup">
		<div v-for="option in options" :key="option.value">
			<label class="controlRadio" :style="[optionDisabled(option) ? {'color':'#bababa'} : {}]" :title="option.title ? option.title : ''">
				<input class="controlRadio-input" type="radio" :disabled="optionDisabled(option)" :value="option.value" :checked="option.value === value" @change="$emit('input', option.value)">
				<span class="controlRadio-state"></span>
				<span class="controlRadio-text">{{ option.text }}</span>
			</label>
		</div>
	</div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
	props: {
		options: {
			type: Array,
			default: () => [],
		},
		condition: {
			type: [Number, null]
		},
		value: {},
	},
	methods: {
		optionDisabled (option) {
			return option.disabled || this.condition === null || this.condition === 0
		}
	}
})
</script>
